/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Tiles_TitleInputs */

const en_ui_thresholds_tiles_title = /** @type {(inputs: Ui_Thresholds_Tiles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your values over time`)
};

const de_ui_thresholds_tiles_title = /** @type {(inputs: Ui_Thresholds_Tiles_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Werte im Verlauf`)
};

/**
* | output |
* | --- |
* | "Your values over time" |
*
* @param {Ui_Thresholds_Tiles_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_tiles_title = /** @type {((inputs?: Ui_Thresholds_Tiles_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Tiles_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_tiles_title(inputs)
	return de_ui_thresholds_tiles_title(inputs)
});